import { userRolePermissionApi } from "@platformx/authoring-apis";
import { ShowToastError, getSelectedSite, menuDisplayOrder } from "@platformx/utilities";
import { useEffect, useState } from "react";
import graphQluserRole from "./api/fetch";
import PermissionTable from "./components/RoleAssignatation/PermissionTable";

const PermissionAssignatation = () => {
  const [loading, setLoading] = useState(false);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [siteModuleList, setSiteModuleList] = useState({
    modulePermissionList: [],
    rolePermissionList: [],
  });
  const groupDataBasedOnCategory = (data) => {
    return data?.sort((a, b) => {
      const categoryA = a?.category?.toLowerCase();
      const categoryB = b?.category?.toLowerCase();
      return categoryA?.localeCompare(categoryB);
    });
  };

  const getPermissions = async () => {
    try {
      setLoading(true);
      // Fetch both API calls in parallel
      const [siteRes, roleRes] = await Promise.allSettled([
        userRolePermissionApi.getSiteModulePermissionList(getSelectedSite(), {
          sitename: getSelectedSite(),
        }),
        graphQluserRole.getRolePermissionList(),
      ]);
      // Extract and update state with both responses
      if (siteRes?.status === "fulfilled" && roleRes?.status === "fulfilled") {
        const groupedData = groupDataBasedOnCategory(
          siteRes?.value?.data?.authoring_siteModulePermissionList || [],
        );
        // Rank each item by its position in menuDisplayOrder; any category not
        // present in menuDisplayOrder gets ranked last (falls to the end).
        const getMenuRank = (item: any) => {
          const index = menuDisplayOrder?.findIndex(
            (menu) => menu.toLowerCase() === item?.category?.toLowerCase(),
          );
          return index === -1 ? menuDisplayOrder.length : index;
        };
        const orderedMenu: any = [...(groupedData || [])].sort(
          (a, b) => getMenuRank(a) - getMenuRank(b),
        );
        setSiteModuleList({
          modulePermissionList: orderedMenu,
          rolePermissionList: roleRes?.value?.data?.authoring_rolePermissionList || [],
        });
      } else {
        ShowToastError("Failed to get permissions list");
      }
    } catch (err: any) {
      ShowToastError("Failed to get permissions list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
  }, [triggerUpdate]);

  return (
    <PermissionTable
      siteModuleList={siteModuleList}
      setTriggerUpdate={setTriggerUpdate}
      setLoading={setLoading}
      loading={loading}></PermissionTable>
  );
};

export default PermissionAssignatation;
